module.exports = "/assets/vectors/logo-short.8063eaee.svg";